import { render, staticRenderFns } from "./modalVerImg.vue?vue&type=template&id=23c52d21&scoped=true"
import script from "./modalVerImg.vue?vue&type=script&lang=js"
export * from "./modalVerImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c52d21",
  null
  
)

export default component.exports